import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import ModernHCheckboxAutoComplete from './ModernHCheckboxAutocomplete';
const ControlledModernHCheckboxAutocomplete = ({ name, control, rules, options, placeholder, label, bg = 'light', disabled = false, error, loading = false, endAdornment, endAdornmentIcon, showDesignation = false, showSelectAll = false, selectAllLabel = 'Select All', selectedCountLabel = 'selected' }) => {
    // Memoize options to avoid unnecessary re-renders
    const memoizedOptions = useMemo(() => options, [options]);
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => {
            // Convert flexible options to OptionType (converting value to string)
            const convertedOptions = useMemo(() => memoizedOptions.map((opt) => ({
                ...opt,
                value: String(opt.value)
            })), [memoizedOptions]);
            // Convert form value (array of values) to OptionType[] for the component
            const fieldValue = field.value || [];
            const selectedOptions = Array.isArray(fieldValue)
                ? convertedOptions.filter((opt) => fieldValue.some((val) => String(val) === opt.value))
                : [];
            return (_jsx(ModernHCheckboxAutoComplete, { options: convertedOptions, value: selectedOptions, onChange: (newOptions) => {
                    // Convert OptionType[] back to array of original values for form
                    // Find original values from memoizedOptions to preserve type (string/number/boolean)
                    const valuesArray = newOptions.map((opt) => {
                        const originalOpt = memoizedOptions.find((o) => String(o.value) === opt.value);
                        return originalOpt ? originalOpt.value : opt.value;
                    });
                    field.onChange(valuesArray);
                }, label: label, placeholder: placeholder, bg: bg, error: error, loading: loading, fullWidth: true, disabled: disabled, endAdornment: endAdornment, endAdornmentIcon: endAdornmentIcon, showDesignation: showDesignation, showSelectAll: showSelectAll, selectAllLabel: selectAllLabel, selectedCountLabel: selectedCountLabel }));
        } }));
};
export default ControlledModernHCheckboxAutocomplete;
